import PropTypes from 'prop-types';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var propTypes = {
  /**
  * The visual style of the list.
  * One of: "standard", "checkmark", "minimal".
  */
  skin: PropTypes.oneOf(['standard', 'checkmark', 'minimal']),

  /**
  * @deprecated
  * Please use skin "minimal" instead.
  */
  minimal: deprecatedProp(PropTypes.bool, 'Please use skin "minimal" instead')
};
var List = createComponent({
  displayName: 'List',
  root: 'ul',
  propTypes: propTypes,
  propConfig: {
    processProps: function processProps(props) {
      var _props_role;

      return _object_spread_props(_object_spread({}, props), {
        // Safari + Voiceover has a "feature" where it doesn't read a list with list-style: none as a list
        // it's fixed in CSS, but also add the role="list" to be extra clear
        // https://gerardkcohen.me/writing/2017/voiceover-list-style-type.html
        role: props.skin === 'minimal' ? (_props_role = props.role) !== null && _props_role !== void 0 ? _props_role : 'list' : props.role
      });
    },
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-list']);
      var _props$skin = props.skin,
          skin = _props$skin === void 0 ? 'standard' : _props$skin,
          _props$minimal = props.minimal,
          minimal = _props$minimal === void 0 ? false : _props$minimal;
      if (skin != 'standard') classNameSet.add("swan-list-skin-".concat(skin));
      if (minimal && (!skin || skin === 'standard')) classNameSet.add("swan-list-skin-minimal");
      return classNameSet;
    }
  }
});
List.defaultProps = {
  skin: 'standard'
};
export { List };